import { Tab, Tooltip, Typography } from '@material-ui/core'
import { setProjectYears, setUncSort, updateDeflators } from '@root-gipro/modules/userProjects/store/actions'
import style from '@root-gipro/shared/TabsComponents/TabsComponents.module.scss'
import { IState } from '@root-gipro/store/interfaces'
import cn from 'classnames'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { TabsGroup } from '../TabsComponents/CustomTabs'

interface IVersion {
	userProjectId: number
	name: string
	is_actual: boolean
	unc_sort: string
}

const types = [
	{
		name: '2024',
		path: '',
	},
]

const TabUnc = ({ path }: { path: string }) => {
	const history = useHistory()
	const dispatch = useDispatch()

	const currentUrl = path.split('/')[1]
	const currentState = currentUrl === 'user-archive' ? 'userArchives' : 'userProjects'
	const { originalObj, projectObj } = useSelector((state: IState) => state[currentState])

	const [versions, setVersions] = useState<IVersion[] | []>([])
	const [tabsDissable, setTabsDissable] = useState(true)

	useEffect(() => {
		let versionsProject: IVersion[] | [] = []
		if (projectObj.versions) {
			versionsProject = [...projectObj.versions]
		}
		setVersions(versionsProject)
	}, [originalObj])
	const currentYear = new Date().getFullYear()

	const handleChange = useCallback(
		(_: React.ChangeEvent<{}>, newVal: string) => {
			if (currentUrl === 'user-archive') return
			dispatch(setUncSort(newVal))

			const uncSort = [...versions].find((version: IVersion) => version?.unc_sort === newVal)

			if (uncSort) {
				history.push(`/${currentUrl}/project/${uncSort.userProjectId}/parameters`)

				Number(projectObj.unc_sort) === 2024 ? Number(projectObj.unc_sort) - 1 : Number(projectObj.unc_sort)

				if (originalObj.yearBegin && originalObj.yearEndOffer) {
					dispatch(setProjectYears(originalObj.yearBegin, originalObj.yearEndOffer))
				} else {
					dispatch(
						setProjectYears(
							Number(projectObj.unc_sort) === 2024 ? Number(projectObj.unc_sort) - 1 : Number(projectObj.unc_sort),
							currentYear
						)
					)
				}

				dispatch(updateDeflators(originalObj.yearBegin as number, originalObj.yearEndOffer as number))
			}
		},
		[projectObj.id, originalObj, versions]
	)


	useEffect(() => {
		if (!projectObj?.id) {
			setTabsDissable(false)
		}
	}, [projectObj])

	return (
		<>
			<TabsGroup
				value={projectObj.unc_sort}
				disabled={currentUrl === 'user-archive'}
				onChange={handleChange}
				className={style.checkPlateTabs}
			>
				{types &&
					types.map((type: any) => (
						<Tooltip
							key={type.name}
							title={
								<Typography>
									Режим расчета по сборнику УНЦ, утверждённому в 2024 году. Базовыми являются расценки 2023 года
								</Typography>
							}
						>
							{projectObj.unc_sort == type.name ? (
								<span>
									<Tab
										className={cn({
											[style.active]: projectObj.unc_sort === type.name,
										})}
										disabled={tabsDissable}
										disableRipple
										label={type.name}
										value={type.name}
									/>
								</span>
							) : (
								<Tab
									className={cn({
										[style.active]: projectObj.unc_sort === type.name,
									})}
									disableRipple
									label={type.name}
									value={type.name}
									disabled={tabsDissable}
								/>
							)}
						</Tooltip>
					))}
			</TabsGroup>
		</>
	)
}

export default TabUnc
